export const requiredDocuments = ["secRecentFilling", "offeringCircular", "offeringMemorandum", "financials"];
